// eslint-disable-next-line import/namespace
import * as constants from "app/static/frontend/imports/desktopConstants"

const searchConstants = {
    // show both icon and text at the most frequent window width and only start hiding at -1 of that which is when manually resize
    // eslint-disable-next-line import/namespace
    PROFILE_HIDE_ICON_BREAKPOINT: constants.MOST_FREQUENT_WINDOW_WIDTH - 1,
    PROFILE_HIDE_TEXT_BREAKPOINT: 1280,
    // eslint-disable-next-line import/namespace
    SEARCH_HIDE_ICON_BREAKPOINT: constants.SECOND_FREQUENT_WINDOW_WIDTH - 1,
    // this is when the dataset with most number of action buttons start to stack, subject to change when Action Button changes
    SEARCH_HIDE_TEXT_BREAKPOINT: 1100,
    BOOLEAN_SEARCH_HELPCENTER_URL: "/help/how-to/714/how-to-use-boolean-search",
}

export default searchConstants
